(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/bingo-card/assets/javascripts/partials/win-anim.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/bingo-card/assets/javascripts/partials/win-anim.js');
"use strict";


const {
  useEffect,
  useRef,
  useState
} = React;
const {
  drawWinAnim
} = svs.bingo_react.components.bingoCard.canvas;

const ANIM_TOTAL_TIME = 4.0 * 1000.0;
const WinAnim = _ref => {
  let {
    lastWinTimestamp = 0
  } = _ref;
  const canvasRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    if (!canvasRef.current) {
      return;
    }
    if (!lastWinTimestamp) {
      return;
    }
    if (new Date().getTime() - lastWinTimestamp > 7500) {
      return;
    }
    setIsVisible(true);
    let animationFrameId;
    const startTime = document.timeline.currentTime;
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    const render = timestamp => {
      const {
        width,
        height
      } = canvas.getBoundingClientRect();
      const {
        devicePixelRatio
      } = window;
      if (canvas.width !== width || canvas.height !== height) {
        canvas.width = width * devicePixelRatio;
        canvas.height = height * devicePixelRatio;
      }
      const elapsedTime = timestamp - startTime;
      const progress = Math.max(Math.min(elapsedTime / ANIM_TOTAL_TIME, 1.0), 0.0);
      drawWinAnim(context, progress, ANIM_TOTAL_TIME);
      if (progress >= 1.0) {
        setIsVisible(false);
      } else {
        animationFrameId = window.requestAnimationFrame(render);
      }
    };
    animationFrameId = window.requestAnimationFrame(render);
    return () => {
      window.cancelAnimationFrame(animationFrameId);
    };
  }, [lastWinTimestamp]);
  const classNames = ['bingo-card-win-anim'];
  if (!isVisible) {
    classNames.push('hide');
  }
  return React.createElement("canvas", {
    className: classNames.join(' '),
    ref: canvasRef
  });
};
setGlobal('svs.bingo_react.components.bingoCard.WinAnim', WinAnim);

 })(window);